import * as React from 'react';
import { cn } from '@/lib/utils';

const MetricCard = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-metric-card', 'relative w-full rounded-xl bg-white shadow-dropshadow transition duration-75 hover:shadow-[0px_4px_20px_rgba(68,_43,_140,_0.25)]', 'flex flex-col border border-solid border-neutral-lightest px-5 py-4', className)}
    {...props}
  />
));
MetricCard.displayName = 'MetricCard';

const MetricCardTitle = React.forwardRef(({ className, ...props }, ref) => (
  <h3
    ref={ref}
    className={cn('c-metric-card-title', 'mb-0 line-clamp-3 min-w-5 flex-grow text-base font-bold leading-tight text-primary-dark', className)}
    {...props}
  />
));
MetricCardTitle.displayName = 'MetricCardTitle';

const MetricCardBody = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-metric-card-body', 'flex flex-wrap items-center justify-between gap-3', className)}
    {...props}
  />
));
MetricCardBody.displayName = 'MetricCardBody';

const MetricCardMedal = React.forwardRef(({ className, ...props }, ref) => (
  <img
    ref={ref}
    className={cn('c-metric-card-medal', 'absolute right-0 top-0 w-9 -translate-y-[40%] translate-x-[40%]', className)}
    {...props}
  />
));
MetricCardMedal.displayName = 'MetricCardMedal';

const MetricCardDescription = React.forwardRef(({ className, ...props }, ref) => (
  <p
    ref={ref}
    className={cn('c-metric-card-description', 'mb-0 w-[252px] max-w-[352px] text-sm', className)}
    {...props}
  />
));
MetricCardDescription.displayName = 'MetricCardDescription';

export { MetricCard, MetricCardTitle, MetricCardBody, MetricCardMedal, MetricCardDescription };
